export default {
    mapIconPicker_error: "Error al obtener los iconos del mapa",
    mapIconPicker_places: "Lugares",
    mapIconPicker_maps: "Mapas",
    mapIconPicker_chooseIcon: "Elegir ícono",
    mapIconPicker_defaultIcon: "Ícono por defecto",
    mapIconPicker_chooseColor: "Elegir color",
};